export type DashlyControlSize = "sm" | "md" | "lg";

/** CSS modifier class for {@link DashlyControlSize} token overrides. */
export const dashlyControlSizeClass = (size: DashlyControlSize = "md"): string =>
    `dashly-control-size--${size}`;
